module.exports = __webpack_public_path__ + "static/img/image_transaction_background_top.bcfa7ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image_transaction_background_top.png
// module id = 386
// module chunks = 1